// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NC_It","toggle":"styles_toggle__3KbkF","preview":"styles_preview__1q_Rp"};